import { render, staticRenderFns } from "./SysLang.vue?vue&type=template&id=36d16120&"
import script from "./SysLang.vue?vue&type=script&lang=js&"
export * from "./SysLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports